import { faListOl } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RecarregarDoCache from '@mui/icons-material/Refresh';
import { AppBar, Box, Toolbar, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/cabecalho.css';
import ReactComponent from '../ReactComponent';
import BuscarProcessoPorNumero from './BuscarProcessoPorNumero';
import ControleDeSessao from './ControleDeSessao';
import Cronometro from './Cronometro';
import FiltrarPorNumerosProcessos from './FiltrarPorNumerosProcessos';
import IncluirProcessoSessao from './IncluirProcessoSessao';
import ModalConfirmacao from './ModalConfirmacao';
import ModalControleAdvogados from './ModalControleAdvogados';
import ModalListaPreferencias from './ModalListaPreferencias';
import ModalPendenciasSessao from './ModalPendenciasSessao';
import ModalPresidenteSessao from './ModalPresidenteSessao';
import ModalProcuradorSessao from './ModalProcuradorSessao';
import NotificacoesVotoAlterado from './NotificacoesVotoAlterado';
import ProcessoApregoado from './ProcessoApregoado';
import ProgressoProcessamentoLote from './ProgressoProcessamentoLote';
import QuantidadeVistasMesa from './QuantidadeVistasMesa';
import RecarregarCacheServidor, { MODULO } from './RecarregarCacheServidor';
import DownloadAta from './toolbar/DownloadAta';
import ModalControlePermissaoSustentacao from './ModalControlePermissaoSustentacao';
import AlertasQuorum from './AlertasQuorum';

class ToolbarSalaSessao extends ReactComponent {
    cursor = 'pointer';
    modalConfirmacaoListaPreferenciasOpen = false;

    recarregarListaProcessos = async () => {
        this.mudarCursorWait();
        await this.salaSessaoStore.recarregarListaProcessos();
        this.mudarCursorPointer();
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            cursor: observable,
            modalConfirmacaoListaPreferenciasOpen: observable,
            recarregarListaProcessos: action,
            mudarCursorWait: action,
            mudarCursorPointer: action,
            handleClickOrdenarSustentacoes: action,
            callbackConfirmarFecharListaPreferencias: action,
            callbackCancelarFecharListaPreferencias: action,
            pointerEvents: computed,
            sessoes: computed
        });
    }

    mudarCursorWait() {
        this.cursor = 'wait';
    }

    mudarCursorPointer() {
        this.cursor = 'pointer';
    }

    handleClickOrdenarSustentacoes = async () => {
        if (!this.sessaoStore.sessaoSelecionada) {
            this.mensagemStore.abrirMensagemInfo(
                'Não há sessão selecionada ou não existem processos na sessão selecionada.'
            );
        } else this.modalConfirmacaoListaPreferenciasOpen = true;
    };

    callbackConfirmarFecharListaPreferencias = async () => {
        this.modalConfirmacaoListaPreferenciasOpen = false;
        const alteracoes = await this.sustentacoesService.ordenar(this.sessaoStore.sessaoSelecionada.processos);

        if (alteracoes > 0) {
            await this.salaSessaoStore.recarregarListaProcessos(true);
        }

        await this.sessaoService.fecharLivroPreferencias(this.sessaoStore.idSessaoSelecionada);
        this.mensagemStore.abrirMensagemSucesso('Inscrições de advogados ordenadas.');
    };

    callbackCancelarFecharListaPreferencias = () => {
        this.modalConfirmacaoListaPreferenciasOpen = false;
    };

    renderModalOrdenarSustentacoes() {
        return (
            <ModalConfirmacao
                open={this.modalConfirmacaoListaPreferenciasOpen}
                callbackConfirmar={this.callbackConfirmarFecharListaPreferencias}
                callbackCancelar={this.callbackCancelarFecharListaPreferencias}
                titulo={'Fechar e ordenar inscrições de advogados'}
            >
                <Typography>
                    Deseja ordenar as inscrições conforme Regimento Interno, sobrescrevendo sequenciais já atribuídos e
                    sem deixar lacunas?
                </Typography>
            </ModalConfirmacao>
        );
    }

    get pointerEvents() {
        return this.cursor === 'wait' ? 'none' : 'auto';
    }

    get sessoes() {
        return (this.sessaoStore.sessaoSelecionada && this.sessaoStore.sessaoSelecionada.sessoes) || [];
    }

    render() {
        return (
            <AppBar
                position="static"
                className="selectionAmarelo"
                style={{ display: this.sessaoStore.idSessaoSelecionada !== -1 ? '' : 'none', zIndex: '1' }}
            >
                <Toolbar
                    variant="dense"
                    sx={{
                        display: 'flex',
                        backgroundColor: '#1976d2',
                        minHeight: '40px',
                        color: 'black',
                        paddingLeft: '14px'
                    }}
                    style={{ padding: '0px 8px', zIndex: '1' }}
                >
                    <div style={{ marginRight: '10px' }}>
                        <BuscarProcessoPorNumero
                            processos={this.store.processosSessao}
                            callbackAbrirProcesso={this.store.abrirProcesso}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            color: 'white',
                            marginLeft: '2px'
                        }}
                    >
                        <FiltrarPorNumerosProcessos storeListagemProcessos={this.salaSessaoStore} />
                    </div>
                    <div
                        style={{
                            boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                            width: '2px',
                            margin: '4px',
                            height: '24px',
                            color: 'white'
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            justifyContent: 'space-between',
                            flexGrow: '1',
                            alignItems: 'center',
                            height: '40px'
                        }}
                    >
                        <div style={{ marginLeft: '10px' }}>
                            <QuantidadeVistasMesa />
                        </div>
                        <ProcessoApregoado />
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <AlertasQuorum />
                            {this.renderFerramentas()}
                        </Box>
                    </div>
                </Toolbar>
            </AppBar>
        );
    }

    renderFerramentas() {
        return (
            <div style={{ display: 'flex', color: 'white', alignContent: 'center', alignItems: 'center' }}>
                <div
                    style={{
                        boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                        width: '2px',
                        margin: '4px',
                        height: '24px',
                        color: 'white'
                    }}
                />
                <span style={{ pointerEvents: this.pointerEvents, display: 'flex', alignItems: 'center' }}>
                    <NotificacoesVotoAlterado />
                    <ProgressoProcessamentoLote />
                </span>
                <Tooltip title={<Typography>Recarregar dados da sessão</Typography>}>
                    <span>
                        <IconButton
                            className="corBotaoAmarelo"
                            onClick={this.recarregarListaProcessos}
                            disabled={this.cursor === 'wait' ? true : false}
                        >
                            <RecarregarDoCache sx={{ color: 'white', cursor: this.cursor }} />
                        </IconButton>
                    </span>
                </Tooltip>
                <RecarregarCacheServidor modulo={MODULO.SALA_SESSAO} />
                <ControleDeSessao recarregarListaProcessos={this.recarregarListaProcessos} />
                <Box sx={{ pointerEvents: this.pointerEvents }}>
                    <ModalControlePermissaoSustentacao />
                </Box>
                <IncluirProcessoSessao />
                {this.renderOrdenarSustentacoes()}
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ModalListaPreferencias />
                </div>
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ModalControleAdvogados />
                </div>
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ModalPresidenteSessao corIcone="white" />
                </div>
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <ModalProcuradorSessao
                        corIcone="white"
                        sessoes={this.sessoes}
                    />
                </div>
                <ModalPendenciasSessao />
                <DownloadAta
                    cursor={this.cursor}
                    pointerEvents={this.pointerEvents}
                />

                <div
                    style={{
                        boxShadow: '2px 0px 0px 0px rgba(0,0,0,0.2)',
                        width: '2px',
                        margin: '4px',
                        height: '24px',
                        color: 'white'
                    }}
                />
                <div style={{ pointerEvents: this.pointerEvents }}>
                    <Cronometro cor="white" />
                </div>
            </div>
        );
    }

    renderOrdenarSustentacoes() {
        return (
            this.isComponenteHabilitado('OrdenarSustentacoes') && (
                <>
                    <Tooltip
                        title={'Fechar e ordenar inscrições de advogados'}
                        placement="top-start"
                    >
                        <div
                            style={{ display: 'flex', cursor: this.cursor, fill: 'white' }}
                            className="corBotaoAmarelo"
                        >
                            <FontAwesomeIcon
                                icon={faListOl}
                                onClick={this.handleClickOrdenarSustentacoes}
                                style={{
                                    pointerEvents: this.pointerEvents,
                                    cursor: this.cursor,
                                    width: '23px',
                                    height: '23px',
                                    margin: '8px'
                                }}
                            />
                        </div>
                    </Tooltip>
                    {this.renderModalOrdenarSustentacoes()}
                </>
            )
        );
    }
}

export default inject('stores')(observer(ToolbarSalaSessao));
